export default __webpack_public_path__ + "static/media/1966.49a50597.png";